import React from 'react';
import { Helmet } from 'react-helmet';
import { useWindowSize } from '../../hooks/useWindowSize';
import { appConst } from '../../AppConst';

export interface IPageProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: string
}

const Page = (props: IPageProps) => {
    const { height } = useWindowSize();
    return (
        <>
            <Helmet>
                <title>{props.title}</title>
            </Helmet>
            <div
                {...props}
                style={{
                    paddingTop: 15,
                    padding: 5,
                    backgroundColor: "#fff",
                    minHeight: height - appConst.headerHeight,
                    height: height - 100,
                    overflow: "auto",
                    borderRadius: 2,
                    ...props.style
                }}
            >
                {props.children}
            </div>
            
            
        </>
    );
};

export default Page;